import { IFAQInformation } from "../types";

export const FAQData = {
  RU: [
    {
      type: "common",
      options: [
        {
          title: "Что такое Blogix",
          text: "Мы — Blogix, сервис для размещения рекламы на публичных и приватных площадках в Telegram, Instagram и YouTube. У нас вы можете легко создать рекламный пост с активной ссылкой на ваш сайт, товар, приложение или другой ресурс, добавить видео, фото и текст, чтобы начать продвижение вашего продукта среди широкой аудитории. Все площадки в нашем каталоге разделены по тематикам, что упрощает поиск подходящих каналов и помогает эффективно нацелиться на вашу аудиторию.",
        },
        {
          title: "В чем преимущество Blogix?",
          text: "C помощью нашего сервиса Вы привлечете внимание нужной вам аудитории, увеличите просмотры и получите реальные результаты. Мы гарантируем безопасное выполнение заказа как для владельцев площадок, так и для рекламодателей. Это сэкономит ваше время и силы, позволяя сосредоточиться на главном.",
        },
        {
          title: "Какие гарантии?",
          text: "Наша система безопасной сделки гарантирует, что ваш рекламный пост будет опубликован на выбранных площадках из каталога строго в соответствии с вашими требованиями. Если размещение не состоится или не будет соответствовать вашим условиям, мы вернем полную сумму заказа.",
        },
        {
          title: "Как с вами связаться?",
          text: "Чтобы всегда быть в курсе обновлений, подписывайтесь на наш Telegram-канал или следите за новостями на сайте. Если у вас есть вопросы о работе сервиса, вы можете написать в наш Telegram-бот службы поддержки или воспользоваться онлайн-чатом прямо на сайте.",
        },
        {
          title: "Как работает механизм «Безопасной сделки»?",
          text: "Средства Заказчика резервируются платформой до момента завершения рекламной кампании и подтверждения размещения. Только после этого оплата поступает Владельцу. Это исключает риск недобросовестного исполнения с обеих сторон.",
        },
        {
          title: "Что означает акцепт оферты?",
          text: "Акцепт — это полное и безоговорочное принятие условий оферты. Он происходит при регистрации на платформе, подписании оферты через ЭДО или фактическом использовании сервиса.",
        },
        {
          title: "Какой документ подтверждает сотрудничество с Blogix?",
          text: "Публичная оферта, подписанная через ЭДО, заменяет бумажный договор и имеет юридическую силу. Также подписываются счета, инвойсы и акты через didox.uz.",
        },
      ],
    },
    {
      type: "advertiser",
      options: [
        {
          title: "Как мне разместить рекламу с помощью платформы Blogix?",
          text: "Чтобы разместить рекламу, просто зарегистрируйтесь, перейдите в наш каталог и выберите подходящие каналы. Для удобства используйте фильтры, чтобы быстро найти площадки с вашей целевой аудиторией. Затем добавьте выбранные каналы в корзину, укажите формат размещения, задайте название проекта, создайте пост, выберите удобные даты публикации и оплатите заказ. Всё готово!",
        },
        {
          title: "Вы можете помочь мне подобрать каналы?",
          text: "Конечно! Мы предлагаем услугу “Готовые решения под ключ”, где наши эксперты бесплатно подберут подходящие каналы для вашей рекламы. Менеджер поможет выбрать площадки для достижения ваших целей и полностью возьмет на себя сопровождение вашей рекламной кампании на всех этапах.",
        },
        {
          title: "Сколько стоит размещение рекламы на канале?",
          text: "Цены на размещение рекламы в каналах указаны в нашем Каталоге и устанавливаются владельцами каналов самостоятельно.",
        },
        {
          title: "Как пополнить баланс?",
          text: "Мы принимаем платежи через популярные системы, такие как Payme и Click. Для компаний и индивидуальных предпринимателей доступна оплата по безналичному расчету через договор с использованием Didox. Если вам удобен другой способ оплаты, просто свяжитесь с нами, и мы найдем решение!",
        },
        {
          title:
            "Что обозначают форматы размещения 1/24, 2/48, 3/72, 7 дней и «нативный»?",
          text: "Это форматы размещения вашего рекламного поста на канале блогера, например 1/24 - означает что пост будет 1 час в топе канала (после вашего рекламного поста в течение одного часа на канале не будут выкладываться посты, пользователи будут видеть ваш рекламный пост самым первым сообщением в канале) и 24 часа в ленте канала, после чего рекламный пост будет удален из истории канала (по усмотрению блогера рекламный пост может оставаться в ленте канала навсегда)",
        },
        {
          title: "Деньги списались с баланса, а поста нет, что делать?",
          text: "Не переживайте — все заказы защищены системой безопасная сделка. Ваши деньги резервируются платформой и передаются владельцу канала только после выполнения заказа. Если в течение 24 часов заказ не будет принят, средства автоматически возвращаются на ваш баланс в личном кабинете, если заказ принят у владельца канала есть 36 часов после принятия для размещения рекламного заказа, если иные сроки не указаны в условиях заказа.",
        },
        {
          title: "Когда на канале появится моя интеграция?",
          text: "Владелец канала должен принять проект в течение 24 часов. После этого у него есть 36 часов для публикации, если иные сроки не указаны в условиях заказа.",
        },
        {
          title: "Что будет если канал откажет в размещении моей интеграции?",
          text: "Если владелец канала откажется от размещения, средства будут возвращены на ваш баланс в течение 24 часов.",
        },
        {
          title:
            "Чем отличается «Запуск под ключ» от обычной покупки через каталог?",
          text: "При покупке через каталог вы сами выбираете каналы и управляете размещением. В «Запуске под ключ» менеджер Blogix подбирает каналы, составляет медиаплан и запускает РК за вас.",
        },
        {
          title: "Могу ли я изменить состав медиаплана при запуске под ключ?",
          text: "Да, если вы выбрали тариф Стандартный или Комплексный. Вы можете вносить правки до момента утверждения медиаплана.",
        },
        {
          title: "Когда я получу отчет и документы?",
          text: "По завершении кампании вы получите: финальный отчет по размещениям, счет-фактуру и акт выполненных работ через систему didox.uz.",
        },
        {
          title: "Можно ли вернуть средства за запуск под ключ?",
          text: "Нет, если вы уже утвердили медиаплан. Возврат возможен только в случае невозможности запуска РК по вине Blogix или при форс-мажоре.",
        },
      ],
    },
    {
      type: "blogger",
      options: [
        {
          title: "Как добавить свой канал в каталог платформы?",
          text: "Чтобы добавить свой канал, зарегистрируйтесь на нашем сайте. После регистрации перейдите в режим владельца канала, зайдите в раздел “Мои каналы” в личном кабинете и следуйте инструкции по добавлению канала. Это абсолютно бесплатно. После подачи заявки ваш канал пройдет модерацию. Если у него более 1000 подписчиков и он соответствует нашим требованиям, он будет добавлен в каталог.",
        },
        {
          title: "Как быстро мой канал появится в каталоге?",
          text: "Мы стараемся модерировать заявки максимально оперативно, но это занимает время. Обычно не больше 36 часов.",
        },
        {
          title: "Почему мой канал не был добавлен?",
          text: "Убедитесь, что ваш канал или чат соответствуют всем требованиям, указанным в разделе 4 правил пользования сервисом — “Добавление канала”. В случае отказа вы сможете узнать причину в разделе “Мои каналы”, где такие каналы будут отмечены статусом “заблокированные”.",
        },
        {
          title: "Как обновить информацию о моем канале?",
          text: "После добавления канала вы можете изменить описание и другие данные при редактировании в разделе «Мои каналы».",
        },
        {
          title: "Как долго пост должен быть размещен на канале?",
          text: "Стандартные условия размещения интеграций в ленте канала: удержание поста в топе в течение 1 часа и его размещение в ленте на 24 часа. При необходимости вы можете выбрать другие условия размещения в настройках конкретного канала.",
        },
        {
          title: "Как формируется цена?",
          text: " Владельцы каналов сами устанавливают стоимость рекламы в своем канале. После успешного завершения проекта на ваш баланс зачисляется сумма, равная стоимости поста, за вычетом комиссии сервиса в размере 5%. Комиссия за вывод средств зависит от выбранного вами способа вывода.",
        },
        {
          title: "Как сделать вывод средств?",
          text: "Вывод средств можно оформить в личном кабинете, в разделе «Вывод средств», следуя инструкции и расписанию.",
        },
        {
          title: "Я оформил вывод средств, где мои деньги?",
          text: "Заявки на вывод средств обрабатываются трижды в неделю: по понедельникам, средам и пятницам. Зачисление средств на ваш банковский счет или карту зависит от работы принимающего банка или сервиса и обычно занимает не более 1–3 банковских дней.",
        },
        {
          title: "Почему мои каналы пропали из каталога?",
          text: "Любое подозрение в мошеннических действиях на платформе, уменьшение подписчиков канала ниже порогового значения и некоторые другие причины влекут за собой удаление каналов из каталога.",
        },
        {
          title: "Зачем мне подключать вашего бота?",
          text: "Это Telegram-бот, который мгновенно уведомляет вас о всех обновлениях на платформе. Бот сообщает о новых заказах (с возможностью принять или отклонить), изменениях статуса заказа, пополнении баланса и других важных событиях. Подключив бот уведомлений Telega.in, вы будете получать новые рекламные запросы в реальном времени, что позволит быстро реагировать на запросы рекламодателей. Подробнее о подключении бота к вашему аккаунту можно узнать здесь.",
        },
        {
          title: "Когда я получу оплату за заказ?",
          text: "После подтверждения размещения Заказчиком или по истечении 72 часов с момента публикации, если не поступила жалоба.",
        },
        {
          title: "Какие документы мне нужно подписывать?",
          text: "Вам отправляется: бессрочный договор и правила сервиса; счета, акты и инвойсы после завершения заказа — через ЭДО didox.uz.",
        },
        {
          title: "Почему мой канал могут не принять в каталог?",
          text: "Причины отклонения: менее 1000 подписчиков; заблокированность, неактивность; неестественная активность или накрутка; запрещённый или политический контент; отсутствие данных в аналитике.",
        },
      ],
    },
  ] as IFAQInformation[],
  EN: [
    {
      type: "common",
      options: [
        {
          title: "What is Blogix?",
          text: "We are Blogix, a service for advertising on public and private platforms in Telegram, Instagram, and YouTube. With us, you can easily create an ad post with an active link to your website, product, app, or other resource, add video, photos, and text to start promoting your product to a broad audience. All platforms in our catalog are categorized by topics, making it easier to find suitable channels and effectively target your audience.",
        },
        {
          title: "What are the advantages of Blogix?",
          text: "With our service, you will attract the right audience, increase views, and achieve real results. We guarantee the safe execution of orders for both platform owners and advertisers. This saves you time and effort, allowing you to focus on what matters most.",
        },
        {
          title: "What guarantees do you provide?",
          text: "Our secure transaction system ensures that your ad post will be published on the selected platforms from our catalog strictly according to your requirements. If the placement does not take place or does not meet your conditions, we will refund the full order amount.",
        },
        {
          title: "How can I contact you?",
          text: "To stay updated, subscribe to our Telegram channel or follow the news on our website. If you have any questions about our service, you can message our Telegram support bot or use the online chat directly on the website.",
        },
        {
          title: "How does the 'Safe Transaction' mechanism work?",
          text: "The funds of the Customer are reserved by the platform until the completion of the advertising campaign and the confirmation of the placement. Only after this, the payment is transferred to the Owner. This excludes the risk of non-fulfillment from both sides.",
        },
        {
          title: "What does 'Acceptance of the offer' mean?",
          text: "Acceptance is the full and unconditional acceptance of the terms of the offer. It occurs when registering on the platform, signing the offer through EDM or actual use of the service.",
        },
        {
          title: "What document confirms the cooperation with Blogix?",
          text: "The public offer, signed through EDM, replaces the paper contract and has legal force. Also, invoices and acts are signed through didox.uz.",
        },
      ],
    },
    {
      type: "advertiser",
      options: [
        {
          title: "How can I place an ad using the Blogix platform?",
          text: "To place an ad, simply register, go to our catalog, and choose the appropriate channels. Use filters for convenience to quickly find platforms with your target audience. Then, add the selected channels to your cart, specify the placement format, set a project name, create a post, select convenient publication dates, and complete the payment. That's it!",
        },
        {
          title: "Can you help me choose the right channels?",
          text: "Of course! We offer a 'Turnkey Solutions' service, where our experts will select the best channels for your ad free of charge. A manager will help you choose platforms to achieve your goals and will fully oversee your ad campaign at all stages.",
        },
        {
          title: "How much does it cost to place an ad on a channel?",
          text: "Advertising placement prices are listed in our Catalog and are set by channel owners independently.",
        },
        {
          title: "How can I top up my balance?",
          text: "We accept payments through popular systems such as Payme and Click. For companies and individual entrepreneurs, non-cash payment via contract through Didox is available. If you prefer another payment method, just contact us, and we'll find a solution!",
        },
        {
          title:
            "What do placement formats 1/24, 2/48, 3/72, 7 days, and 'native' mean?",
          text: "These are ad post placement formats on a blogger's channel. For example, 1/24 means that the post will stay at the top of the channel for 1 hour (no other posts will be published during this hour, so users will see your ad as the first message in the channel) and will remain in the channel feed for 24 hours, after which it may be removed from the channel's history at the blogger's discretion (or remain permanently).",
        },
        {
          title:
            "The money was deducted from my balance, but the post is missing. What should I do?",
          text: "Don't worry — all orders are protected by our secure transaction system. Your funds are reserved by the platform and transferred to the channel owner only after the order is fulfilled. If the order is not accepted within 24 hours, the funds will automatically be returned to your balance. If accepted, the channel owner has 36 hours to publish the ad, unless otherwise specified in the order terms.",
        },
        {
          title: "When will my ad integration appear on the channel?",
          text: "The channel owner must accept the project within 24 hours. After that, they have 36 hours to publish it, unless other deadlines are specified in the order terms.",
        },
        {
          title:
            "What happens if the channel refuses to publish my integration?",
          text: "If the channel owner declines the placement, the funds will be returned to your balance within 24 hours.",
        },
        {
          title:
            "How does 'Turnkey Solutions' differ from a regular purchase through the catalog?",
          text: "When purchasing through the catalog, you choose the channels and manage the placement yourself. In 'Turnkey Solutions', a Blogix manager selects channels, creates a media plan, and launches the campaign on your behalf.",
        },
        {
          title:
            "Can I change the media plan composition during 'Turnkey Solutions'?",
          text: "Yes, if you have selected the Standard or Complex tariff. You can make changes until the media plan is approved.",
        },
        {
          title: "When will I receive the report and documents?",
          text: "After the campaign is completed, you will receive: a final report on placements, an invoice, and an act of completed work through the didox.uz system.",
        },
        {
          title: "Can I get a refund for 'Turnkey Solutions'?",
          text: "No, if you have already approved the media plan. Refund is only possible if the campaign cannot be launched due to Blogix's fault or a force majeure.",
        },
      ],
    },
    {
      type: "blogger",
      options: [
        {
          title: "How can I add my channel to the platform's catalog?",
          text: "To add your channel, register on our website. After registration, switch to channel owner mode, go to the 'My Channels' section in your personal account, and follow the instructions to add your channel. This is completely free. Once submitted, your channel will undergo moderation. If it has more than 1,000 subscribers and meets our requirements, it will be added to the catalog.",
        },
        {
          title: "How quickly will my channel appear in the catalog?",
          text: "We strive to moderate applications as quickly as possible, but this takes time. Usually, no more than 36 hours.",
        },
        {
          title: "Why wasn't my channel added?",
          text: "Make sure your channel or chat meets all the requirements listed in Section 4 of the service rules — 'Adding a Channel.' If your application is rejected, you can find the reason in the 'My Channels' section, where such channels will be marked as 'blocked.'",
        },
        {
          title: "How can I update my channel information?",
          text: "After adding a channel, you can edit the description and other details in the 'My Channels' section.",
        },
        {
          title: "How long should a post stay on the channel?",
          text: "The standard conditions for integrations in a channel feed include keeping the post at the top for 1 hour and in the feed for 24 hours. If needed, you can select different placement conditions in the specific channel settings.",
        },
        {
          title: "How is the price determined?",
          text: "Channel owners set their own advertising prices. After a successful transaction, the amount equal to the post price minus a 5% platform commission is credited to your balance. The withdrawal fee depends on the chosen withdrawal method.",
        },
        {
          title: "How can I withdraw funds?",
          text: "You can request a withdrawal in your personal account under the 'Withdraw Funds' section by following the instructions and schedule.",
        },
        {
          title: "I requested a withdrawal, where is my money?",
          text: "Withdrawal requests are processed three times a week: on Mondays, Wednesdays, and Fridays. The time it takes for funds to reach your bank account or card depends on the receiving bank or payment service and usually takes no more than 1–3 business days.",
        },
        {
          title: "Why did my channels disappear from the catalog?",
          text: "Any suspicion of fraudulent activities on the platform, a decrease in subscribers below the threshold, and certain other reasons may lead to the removal of channels from the catalog.",
        },
        {
          title: "Why should I connect your bot?",
          text: "This is a Telegram bot that instantly notifies you of all updates on the platform. The bot informs you about new orders (with the ability to accept or decline), order status changes, balance updates, and other important events. By connecting the Telega.in notification bot, you will receive new advertising requests in real-time, allowing you to respond quickly to advertisers. Learn more about connecting the bot to your account here.",
        },
        {
          title: "When will I receive payment for an order?",
          text: "After the placement is confirmed by the Customer or after 72 hours from the publication, if there is no complaint.",
        },
        {
          title: "What documents do I need to sign?",
          text: "You will receive: a perpetual contract and service rules; invoices, acts, and invoices after the completion of the order — through EDM didox.uz.",
        },
        {
          title: "Why might my channel be rejected from the catalog?",
          text: "Reasons for rejection: less than 1000 subscribers; blocked, inactive; unnatural activity or spam; prohibited or political content; absence of data in analytics.",
        },
      ],
    },
  ] as IFAQInformation[],
  UZ: [
    {
      type: "common",
      options: [
        {
          title: "Blogix nima?",
          text: "Biz — Blogix, Telegram, Instagram va YouTube'dagi ommaviy va shaxsiy maydonchalarda reklama joylashtirish xizmati. Bizning platformamizda siz veb-saytingiz, mahsulotingiz, ilovangiz yoki boshqa resursingizga faol havola bilan reklama posti yaratishingiz, video, rasm va matn qo‘shishingiz mumkin. Bu mahsulotingizni keng auditoriyaga targ'ib qilishni boshlashga yordam beradi. Katalogimizdagi barcha maydonchalar mavzularga ajratilgan bo‘lib, bu sizga mos kanallarni osongina topishga va auditoriyangizni samarali yo‘naltirishga yordam beradi.",
        },
        {
          title: "Blogixning qanday afzalliklari bor?",
          text: "Bizning xizmatimiz yordamida siz kerakli auditoriyaning e’tiborini tortasiz, ko‘rishlar sonini oshirasiz va haqiqiy natijalarga erishasiz. Biz ham maydoncha egalari, ham reklama beruvchilar uchun buyurtmaning xavfsiz bajarilishini kafolatlaymiz. Bu sizning vaqtingiz va kuchingizni tejaydi, asosiy maqsadlarga e’tibor qaratishingizga imkon beradi.",
        },
        {
          title: "Kafolatlar qanday?",
          text: "Bizning xavfsiz bitim tizimimiz reklamangiz tanlangan katalog maydonchalarida sizning talablaringizga qat’iy muvofiq joylashtirilishini kafolatlaydi. Agar joylashtirish amalga oshmasa yoki shartlaringizga mos kelmasa, biz buyurtma summasini to‘liq qaytaramiz.",
        },
        {
          title: "Siz bilan qanday bog‘lanish mumkin?",
          text: "Yangiliklardan doimo xabardor bo‘lish uchun bizning Telegram kanalimizga obuna bo‘ling yoki yangiliklarni veb-saytimizda kuzatib boring. Agar xizmatimiz bo‘yicha savollaringiz bo‘lsa, bizning Telegram qo‘llab-quvvatlash botimizga yozishingiz yoki saytdagi onlayn chatdan foydalanishingiz mumkin.",
        },
        {
          title: "Xavfsiz bitim mexanizmi qanday ishlaydi?",
          text: "Buyurtmachining mablag'lari reklama kampaniyasi tugaguniga va joylashtirish tasdiqlanguniga qadar platforma tomonidan rezerv qilinadi. Faqat shundan keyin to'lov Egasi hisobiga o'tkaziladi. Bu ikkala tomondan ham noto'g'ri bajarilish xavfini bartaraf etadi.",
        },
        {
          title: "Oferta aksepti nimani anglatadi?",
          text: "Aksept - bu oferta shartlarining to'liq va shartsiz qabul qilinishi. U platformada ro'yxatdan o'tishda, EXA orqali ofertani imzolashda yoki xizmatdan amalda foydalanishda yuzaga keladi.",
        },
        {
          title: "Blogix bilan hamkorlikni qaysi hujjat tasdiqlaydi?",
          text: "EXA orqali imzolangan ommaviy oferta qog'oz shartnomani almashtiradi va huquqiy kuchga ega. Shuningdek, hisob-fakturalar va aktlar didox.uz orqali imzolanadi.",
        },
      ],
    },
    {
      type: "advertiser",
      options: [
        {
          title: "Blogix platformasi orqali reklama qanday joylashtiriladi?",
          text: "Reklama joylashtirish uchun shunchaki ro‘yxatdan o‘ting, katalogimizga kiring va mos kanallarni tanlang. Sizga qulay bo‘lishi uchun filtrlar yordamida o‘z auditoriyangizga mos maydonlarni tez topishingiz mumkin. So‘ng, tanlangan kanallarni savatchaga qo‘shing, joylashtirish formatini belgilang, loyihangiz nomini kiriting, post yarating, qulay nashr sanalarini tanlang va buyurtmani to‘lang. Hammasi tayyor!",
        },
        {
          title: "Siz menga kanallarni tanlashda yordam bera olasizmi?",
          text: "Albatta! Biz “Tayyor yechimlar” xizmatini taklif qilamiz, bu xizmat doirasida mutaxassislarimiz siz uchun mos kanallarni bepul tanlab berishadi. Menejer sizning maqsadlaringizga mos maydonlarni tanlashda yordam beradi va reklama kampaniyangizni barcha bosqichlarda kuzatib boradi.",
        },
        {
          title: "Kanallarda reklama joylashtirish narxi qancha?",
          text: "Kanallarda reklama joylashtirish narxlari bizning katalogimizda ko‘rsatilgan bo‘lib, ularni kanal egalari mustaqil belgilaydi.",
        },
        {
          title: "Balansni qanday to‘ldirish mumkin?",
          text: "Biz Payme va Click kabi ommabop to‘lov tizimlari orqali to‘lovlarni qabul qilamiz. Kompaniyalar va yakka tartibdagi tadbirkorlar uchun Didox orqali shartnoma asosida bank o‘tkazmalari bilan to‘lash imkoniyati mavjud. Agar sizga boshqa to‘lov usuli qulay bo‘lsa, biz bilan bog‘laning, biz siz uchun yechim topamiz!",
        },
        {
          title:
            "1/24, 2/48, 3/72, 7 kun va “nativ” formatlari nimani anglatadi?",
          text: "Bu sizning reklama postingiz bloger kanalida qanday joylashtirilishini anglatadi. Masalan, 1/24 - bu post kanalda 1 soat davomida eng yuqori o‘rinda turishini bildiradi (bu vaqt davomida kanalda boshqa postlar joylashtirilmaydi va foydalanuvchilar sizning reklama postingizni birinchi xabar sifatida ko‘rishadi) hamda 24 soat davomida kanal tasmasida qoladi. Shundan keyin, bloger qaroriga ko‘ra, post tarixdan o‘chirilishi yoki doimiy qolishi mumkin.",
        },
        {
          title: "Pul balansdan yechildi, lekin post yo‘q, nima qilish kerak?",
          text: "Xavotir olmang — barcha buyurtmalar xavfsiz bitim tizimi bilan himoyalangan. Pul mablag‘laringiz platforma tomonidan rezerv qilinadi va faqat buyurtma bajarilgandan so‘ng kanal egasiga o‘tkaziladi. Agar buyurtma 24 soat ichida qabul qilinmasa, mablag‘ avtomatik ravishda shaxsiy kabinetingiz balansiga qaytariladi. Agar buyurtma qabul qilingan bo‘lsa, kanal egasida reklama joylashtirish uchun 36 soat bor, agar buyurtma shartlarida boshqa muddatlar belgilanmagan bo‘lsa.",
        },
        {
          title: "Mening reklama integratsiyam qachon kanalda paydo bo‘ladi?",
          text: "Kanal egasi loyihani 24 soat ichida qabul qilishi kerak. Shundan so‘ng, u reklama postini joylashtirish uchun 36 soatga ega bo‘ladi, agar buyurtma shartlarida boshqa muddatlar ko‘rsatilmagan bo‘lsa.",
        },
        {
          title:
            "Agar kanal mening reklama integratsiyamni rad etsa nima bo‘ladi?",
          text: "Agar kanal egasi reklama joylashtirishni rad etsa, mablag‘ingiz 24 soat ichida balansingizga qaytariladi.",
        },
        {
          title: "«Tayyor loyiha» oddiy buyurtmadan qanday farq qiladi?",
          text: "Katalog orqali xarid qilganda siz o'zingiz kanallarni tanlaysiz va joylashtirishni boshqarasiz. «Tayyor loyiha»da Blogix menejeri kanallarni tanlaydi, media rejani tuzadi va reklama kampaniyasini sizning o'rniga ishga tushiradi.",
        },
        {
          title:
            "Tayyor loyiha davomida media rejani tarkibini o'zgartira olamanmi?",
          text: "Ha, agar siz Standart yoki Kompleks tarifini tanlagan bo'lsangiz. Media reja tasdiqlangunga qadar o'zgartirishlar kiritishingiz mumkin.",
        },
        {
          title: "Hisobot va hujjatlarni qachon olaman?",
          text: "Kampaniya tugagandan so'ng sizga beriladi: joylashtirishlar bo'yicha yakuniy hisobot, hisob-faktura va bajarilgan ishlar akti didox.uz tizimi orqali.",
        },
        {
          title: "Tayyor loyiha uchun mablag'larni qaytara olamanmi?",
          text: "Yo'q, agar siz allaqachon media rejani tasdiqlagan bo'lsangiz. Qaytarish faqat Blogixning aybi yoki force majeure tufayli reklama kampaniyasini ishga tushirish imkoni bo'lmasa mumkin.",
        },
      ],
    },
    {
      type: "blogger",
      options: [
        {
          title: "Kanalimni platforma katalogiga qanday qo‘shishim mumkin?",
          text: "Kanal qo‘shish uchun saytda ro‘yxatdan o‘ting. Ro‘yxatdan o‘tgach, kanal egasi rejimiga o‘ting, shaxsiy kabinetdagi 'Mening kanallarim' bo‘limiga kiring va kanal qo‘shish bo‘yicha ko‘rsatmalarga amal qiling. Bu butunlay bepul. Ariza yuborilgandan so‘ng, kanal moderatsiyadan o‘tadi. Agar kanalda 1000 dan ortiq obunachi bo‘lsa va u talablarimizga javob bersa, u katalogga qo‘shiladi.",
        },
        {
          title: "Kanalim katalogga qanchalik tez qo‘shiladi?",
          text: "Biz arizalarni iloji boricha tez moderatsiya qilishga harakat qilamiz, ammo bu biroz vaqt talab etadi. Odatda 36 soatdan oshmaydi.",
        },
        {
          title: "Nega mening kanal katalogga qo‘shilmadi?",
          text: "Kanal yoki chatingiz xizmat qoidalarining 4-bo‘limidagi 'Kanal qo‘shish' talablariga javob berayotganiga ishonch hosil qiling. Rad etilgan taqdirda, sababini 'Mening kanallarim' bo‘limida bilib olishingiz mumkin, bunday kanallar 'bloklangan' holati bilan belgilangan bo‘ladi.",
        },
        {
          title: "Kanalim haqidagi ma’lumotlarni qanday yangilash mumkin?",
          text: "Kanal qo‘shilganidan so‘ng, siz uning tavsifi va boshqa ma’lumotlarini 'Mening kanallarim' bo‘limida tahrirlash orqali o‘zgartirishingiz mumkin.",
        },
        {
          title: "Post kanal lentasida qancha vaqt turishi kerak?",
          text: "Standart shartlarga ko‘ra, reklama postlari kanalda 1 soat davomida yuqori o‘rinda turadi va 24 soat lentada qoladi. Agar kerak bo‘lsa, har bir kanal sozlamalarida boshqa joylashtirish shartlarini tanlashingiz mumkin.",
        },
        {
          title: "Narx qanday shakllanadi?",
          text: "Kanal egalari o‘z kanallarida reklama narxini mustaqil belgilaydilar. Loyihangiz muvaffaqiyatli yakunlangandan so‘ng, post qiymatidan 5% xizmat komissiyasi ushlab qolingan holda, qolgan mablag‘ balansingizga o‘tkaziladi. Mablag‘larni yechib olish uchun komissiya tanlangan to‘lov usuliga bog‘liq.",
        },
        {
          title: "Mablag‘larni qanday yechib olish mumkin?",
          text: "Mablag‘larni yechib olish uchun shaxsiy kabinetdagi 'Mablag‘ yechib olish' bo‘limiga kiring va yo‘riqnomaga amal qiling.",
        },
        {
          title: "Men mablag‘ yechib olishga ariza berdim, pulim qayerda?",
          text: "Mablag‘ yechib olish bo‘yicha arizalar haftada uch marta – dushanba, chorshanba va juma kunlari ko‘rib chiqiladi. Bank yoki to‘lov xizmatining ishlashiga qarab, mablag‘laringiz odatda 1-3 ish kuni ichida hisobingizga o‘tkaziladi.",
        },
        {
          title: "Nega mening kanallarim katalogdan olib tashlandi?",
          text: "Platformada firibgarlik harakatlariga shubha, obunachilar sonining belgilangan chegaradan pastga tushishi va boshqa ayrim sabablarga ko‘ra kanallar katalogdan olib tashlanishi mumkin.",
        },
        {
          title: "Nega sizning botingizni ulashim kerak?",
          text: "Bu Telegram-bot bo‘lib, platformadagi barcha yangilanishlar haqida sizni tezkor xabardor qiladi. Bot sizga yangi buyurtmalar (ularni qabul qilish yoki rad etish imkoniyati bilan), buyurtma holati o‘zgarishlari, balans to‘ldirilishi va boshqa muhim hodisalar haqida xabar beradi. Telega.in bildirishnoma botini ulagan holda, siz yangi reklama so‘rovlarini real vaqt rejimida qabul qilasiz va reklama beruvchilarning talablariga tezkor javob bera olasiz. Botni hisobingizga qanday ulash haqida batafsil ma’lumotni bu yerda topishingiz mumkin.",
        },
        {
          title: "Buyurtma uchun to'lovni qachon olaman?",
          text: "Buyurtmachi tomonidan joylashtirish tasdiqlangandan so'ng yoki nashr vaqtidan 72 soat o'tgandan so'ng, agar shikoyat bo'lmasa.",
        },
        {
          title: "Qanday hujjatlarni imzolashim kerak?",
          text: "Sizga yuboriladi: muddatsiz shartnoma va xizmat qoidalari; buyurtma tugagandan so'ng hisob-fakturalar, aktlar va invoyslar — EDM didox.uz orqali.",
        },
        {
          title: "Nega mening kanal katalogga qabul qilinmasligi mumkin?",
          text: "Rad etish sabablari: 1000 dan kam obunachi; bloklangan, faol emas; tabiiy bo'lmagan faollik yoki soxta obunachilar; taqiqlangan yoki siyosiy kontent; analitikada ma'lumot yo'qligi.",
        },
      ],
    },
  ] as IFAQInformation[],
};
